<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import Button from 'dashboard/components-next/button/Button.vue';
import DropdownMenu from 'dashboard/components-next/dropdown-menu/DropdownMenu.vue';

const emit = defineEmits(['apply', 'remove']);

const { t } = useI18n();
const showActionsDropdown = ref(false);
const openUpward = ref(false);
const wrapperRef = ref(null);

const menuItems = [
  {
    label: t('LABEL_MGMT.BULK_CONTACT_OPS.ACTIONS.APPLY'),
    action: 'apply',
    value: 'apply',
    icon: 'i-lucide-tag',
  },
  {
    label: t('LABEL_MGMT.BULK_CONTACT_OPS.ACTIONS.REMOVE'),
    action: 'remove',
    value: 'remove',
    icon: 'i-lucide-circle-minus',
  },
];

// Flip the menu upward when the row sits near the viewport bottom, so the
// last rows of the table don't render the menu off-screen.
const toggleMenu = () => {
  if (!showActionsDropdown.value && wrapperRef.value) {
    const { bottom } = wrapperRef.value.getBoundingClientRect();
    openUpward.value = window.innerHeight - bottom < 140;
  }
  showActionsDropdown.value = !showActionsDropdown.value;
};

const handleAction = ({ action }) => {
  showActionsDropdown.value = false;
  if (action === 'apply') emit('apply');
  else if (action === 'remove') emit('remove');
};
</script>

<template>
  <div
    ref="wrapperRef"
    v-on-clickaway="() => (showActionsDropdown = false)"
    class="relative"
  >
    <Button
      v-tooltip.top="$t('LABEL_MGMT.BULK_CONTACT_OPS.ACTIONS.MORE')"
      icon="i-lucide-ellipsis-vertical"
      slate
      sm
      :class="showActionsDropdown ? 'bg-n-alpha-2' : ''"
      @click="toggleMenu"
    />
    <DropdownMenu
      v-if="showActionsDropdown"
      :menu-items="menuItems"
      class="ltr:right-0 rtl:left-0 w-52"
      :class="openUpward ? 'bottom-full mb-1' : 'top-full mt-1'"
      @action="handleAction($event)"
    />
  </div>
</template>
